const TOKEN_KEY = 'auth_token';

function isAuthDisabled(): boolean {
  return (import.meta as any)?.env?.VITE_DISABLE_AUTH === 'true';
}

export function getAuthToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setAuthToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearAuthToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export function isAuthenticated() {
  if (isAuthDisabled()) return true;
  return Boolean(getAuthToken());
}
